// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieNotice_root__3W0Ze","content":"CookieNotice_content__ZB3Um","button":"CookieNotice_button__1aujH"};